import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, take, switchMap, catchError, map, filter } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';
import { SetTitle, SetTags, SetCanonical, SetStructuredData } from '../../store';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';

@Injectable({ providedIn: 'root' })
export class ThemeMetaGuard {
  private dict = new FromDictionaryPipe(this.lang);

  constructor(private store: Store<fromStore.ThemesState>, private lang: LanguageService) {}

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getSelectedTheme).pipe(
      tap(page => {
        if (!page || !page.metaData) {
          return;
        }
        this.store.dispatch(
          SetTitle({
            title: `${page?.metaData?.title} ${
              this.dict.transform('meta-titel-suffix') ? '- ' + this.dict.transform('meta-titel-suffix') : ''
            }`,
          })
        );
        if (page?.canonical) {
          this.store.dispatch(SetCanonical({ url: page.canonical }));
        }
        this.store.dispatch(
          SetTags({
            properties: {
              'description': StringUtility.Truncate(StringUtility.StripHTML(page.metaData.description), 157, '...'),
              'og:image': page.metaData.imageUrl ? `https:${page.metaData.imageUrl}` : '',
              'og:title': `${page.metaData.title} ${this.dict.transform('meta-titel-suffix')}`,
              'og:description': StringUtility.Truncate(StringUtility.StripHTML(page.metaData.description), 157, '...'),
              'twitter:card': 'summary_large_image',
              'twitter:image': page.metaData.imageUrl ? `https:${page.metaData.imageUrl}` : '',
              'twitter:title': `${page.metaData.title} ${this.dict.transform('meta-titel-suffix')}`,
              'twitter:description': StringUtility.Truncate(StringUtility.StripHTML(page.metaData.description), 157, '...'),
            },
          })
        );
        this.store.dispatch(
          SetStructuredData({
            data: {
              '@context': 'http://schema.org',
              '@type': 'WebPage',
              'name': `${page.metaData.title} ${this.dict.transform('meta-titel-suffix')}`,
              'description': StringUtility.Truncate(StringUtility.StripHTML(page.metaData.description), 157, '...'),
              'image': page.metaData.imageUrl ? `https:${page.metaData.imageUrl}` : '',
              'publisher': {
                '@type': 'Organization',
                'name': 'Onze IJssel',
                'logo': {
                  '@type': 'ImageObject',
                  'url': `https://www.onzeijssel.nl/assets/gfx/onze-ijssel-logo.svg`,
                },
              },
            },
          })
        );
      }),
      filter(a => a?.id > 0),
      map(a => true),
      take(1)
    );
  }
}
